import Parse from 'parse';
export const CustomerSatisfactionQuery = Parse.Object.extend('CustomerSatisfaction');
export const RoastLogQuery = Parse.Object.extend('RoastLog');